/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconSelectSkinny12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectSkinny12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M4.081 8.83 1.307 5.748A.75.75 0 0 0 .193 6.752l3.375 3.75a.75.75 0 0 0 1.15-.043l6.376-8.25a.75.75 0 0 0-1.187-.918L4.08 8.831Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectSkinny16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectSkinny16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M5.442 11.44 1.743 7.331A1 1 0 1 0 .257 8.67l4.5 5a1 1 0 0 0 1.534-.058l8.5-11A1 1 0 1 0 13.21 1.39L5.442 11.44Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectSkinny20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectSkinny20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M17.262 2.372a.973.973 0 0 1 1.53 1.202L8.457 16.722a1.46 1.46 0 0 1-2.261.04L1.23 10.895a.973.973 0 1 1 1.486-1.257l4.58 5.413 9.966-12.678Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconSelectSkinny24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectSkinny24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M19.716 4.382a1 1 0 0 1 1.572 1.236L10.665 19.132a1.5 1.5 0 0 1-2.324.042l-5.104-6.032a1 1 0 0 1 1.526-1.292l4.708 5.565L19.716 4.382Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconSelectSkinny = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconSelectSkinny(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconSelectSkinny12 {...iconProps} />;
        case '16':
            return <IconSelectSkinny16 {...iconProps} />;
        case '20':
            return <IconSelectSkinny20 {...iconProps} />;
        case '24':
            return <IconSelectSkinny24 {...iconProps} />;
        default:
            return <IconSelectSkinny24 {...iconProps} />;
    }
});
